module.exports = "/_next/static/images/0449e10607a9d4363bb6460afd885884-pen@mobile320.jpg.webp";